import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmailValidationService, ProgressStatus } from '@appcore/service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-emailValidation'
  , templateUrl: 'emailValidation.component.html'
  , styleUrls: ['../../app.component.css']
  , providers: [ConfirmationService, MessageService, ProgressStatus]
})
export class EmailValidationComponent implements OnInit {
  emailAddress: string;
  key: string;
  loading: boolean;
  public subscription: Subscription;
  today = new Date();  
  validationResponse = '';
  validationView: boolean;

  Status: any = {
    Header: 'Progress Status',
    Message: 'Loading profile...'
  };

  @ViewChild('statusDialog', { static: true }) statusDialog: { visible: boolean; };

  constructor(
    private route: ActivatedRoute
    , private evService: EmailValidationService
    , public confirmationService: ConfirmationService
    , public messageService: MessageService
    , public progressStatus: ProgressStatus
  ) {
  }

  ngOnInit(): void {
    this.today.getFullYear(); // Populate Footer Message
    this.validationCheck();

    // this.requestValidation(this.emailAddress);
  }

  requestValidation(emailAddress: string): void {
    console.log(emailAddress);
    this.evService.requestValidationKey(emailAddress)
      .subscribe((response) => this.key = response)
  }

  validationCheck(): void {
    this.dataProgressStart();
    const guidRegExCI = new RegExp(/[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/i);

    this.dataProgressUpdate();
    if (this.route.snapshot.params['key'].match(guidRegExCI)) {
      this.key = this.route.snapshot.params['key'];
      console.log('Valid Format');
      this.evService.validateEmailByKey(this.key)
        .subscribe((response) => {
          console.log('Validation In Progress...');
          this.validationResponse = response;
          this.dataProgressComplete();
        })
    } else {
      console.log('Invalid Key Format');
      this.dataProgressComplete();
    }
  }

  dataProgressStart(): void {
    this.Status.Message = this.progressStatus.getSentMessage();
    this.loading = true;
  }
  dataProgressUpdate(): void {
    this.Status.Message = this.progressStatus.getReceivedMessage();
  }
  dataProgressComplete(): void {
    setTimeout(() => { this.messageService.clear(); }, 500);
    this.loading = false;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
